import './header.less';

export class Header {

    constructor(wrapper, landing = false){

        this.wrapper = wrapper;
        this.landing = landing; // ladning page 樣式，只需要顯示部分元件

        this.init();
    }

    init(){

        // 重要訊息公告
        const noticeSetting = window.t('importantNotice');

        let Html = '';

        if(this.landing){
            // ladning page 樣式，只需要顯示部分元件
            Html =
            `<div class="main-header centerwpr">
                <a class="logo" href="/" data-country="${window.countryCode}"></a>
                <div class="spacer"></div>
                <div id="extraBtnWpr"></div>
                <div class="user-control"></div>
            </div>`;

        } else {

            // 重要訊息公告按鈕
            let noticeBtn = '';
            if(noticeSetting.display){
                noticeBtn =
                `<div id="btnSA" class="sa-title">
                    <div class="icon">
                        <svg><use xlink:href="/assets/sprites/sprites_solid.svg#info"></use></svg>
                    </div>
                    ${noticeSetting.title}
                    <svg class="arrow"><use xlink:href="/assets/sprites/sprites_solid.svg#angle-right"></use></svg>
                </div>`;
                this.createSAContent();
            }

            Html =
            `<div class="main-header centerwpr">
                <a class="logo" href="/" data-country="${window.countryCode}"></a>
                ${noticeBtn}
                <div id="sysAnnowpr"></div>
                <div id="extraBtnWpr"></div>
                <div class="user-control"></div>
            </div>`;
        }

        this.wrapper.innerHTML = Html;

        if(noticeSetting.display){
            const btnSA = document.getElementById('btnSA');
            if(!btnSA){
                return;
            }
            btnSA.addEventListener('click', (event) => {
                const box = document.getElementById('SABox');
                box.classList.add('open');
            });
        }

    }

    createSAContent(){

        // TEST
        // window.customSetting = 'tcat';

        // 客製化
        const customSetting = window.customSetting;

        // 重要訊息公告設定
        const noticeSetting = window.t('importantNotice');

        let customContent = false;

        // 每次更新公告內容就手動更換一次 key，以確保不被快取
        // 並保留客製化公司可顯示額外內容的彈性
        let key = noticeSetting.key;
        if(customSetting && noticeSetting.custom?.[customSetting]){
            const extra = noticeSetting.custom[customSetting];

            customContent = extra.content;

            // 客製化公司可指定不同的 key
            // 有需要區分內容時才指定，否則沿用通用 key 值
            // 例如只有針對客製化公司的新內容時
            if(Object.hasOwn(extra, 'key')){
                key = extra.key;
            }
        }

        // console.log(key);
        // console.log(customContent);

        let readtag = '';

        // 判斷使用者是否看過公告內容，以及沒看過是否要自動顯示 (popup)
        if(noticeSetting.popup){
            // 自動顯示
            readtag = localStorage.getItem(key) ?? '';
        } else {
            // 不自動顯示
            readtag = 'read';
        }

        const wrapper = document.createElement('div');
        wrapper.id = 'SABox';

        if(readtag === 'read'){
            wrapper.classList.remove('open');
        } else {
            wrapper.classList.add('open');
            localStorage.setItem(key, 'read');
        }

        let list = '';

        let contentArr = null;

        if(customContent){
            contentArr = customContent.concat(noticeSetting.content);
        } else {
            contentArr = noticeSetting.content;
        }

        if(contentArr){
            if(contentArr.length > 1){
                list += '<ol>';
                contentArr.forEach((item, index) => {
                    if(index > 0){
                        list += '<hr />'
                    }
                    list += `<li>${item}</li>`;
                });
                list += '</ol>';
            } else {
                list = `${contentArr[0]}`;
            }
        }

        const html =
        `<div class="box-content">
            <h3 class="sa-title">
                <div class="icon">
                    <svg><use xlink:href="/assets/sprites/sprites_solid.svg#info"></use></svg>
                </div>${noticeSetting.title}
            </h3>
            <div class="innerwpr">
                ${list}
                <div id="SABoxClose">${noticeSetting.close}</div>
            </div>
        </div>
        `;

        wrapper.innerHTML = html;

        document.body.appendChild(wrapper);

        wrapper.addEventListener('click', (event) => {

            const closeBtn = event.target.closest('#SABoxClose');
            if(closeBtn){
                wrapper.classList.remove('open');
            }

        });
    }

}